module.exports = __webpack_public_path__ + "img/dashboard-close.7a547f81.svg";